















import { Component, Vue } from 'vue-property-decorator';
import $ from 'jquery';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import Draw from '@/components/designer/Draw.vue';
import UIModel from '@/components/designer/UIModel.vue';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { EnumDocType } from '@/api/com/MetaPattern/APP/MDA/Common/EnumDocType';
import WebPageDoc from './WebPageDoc.vue';
import { EnumComponentTypeMD } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';

@Component({
  components: {
    Draw,
    UIModel,
    WebPageDoc
  }
})
export default class MultiDoc extends Vue {
  curTab = '';
  private tabData: any[] = [];
  created() {
    EventBus.$on('openDoc', (component: BaseComponent) => {
      this.openDoc(component);
    });
    EventBus.$on('openPage', (url: string, name: string, displayName: string, transferData: any) => {
      this.openPage(url, name, displayName, transferData);
    });
    EventBus.$on('removeTab', (targetName: string) => {
      this.removeTab(targetName);
    });
    EventBus.$on('pgValueChanged', (name: string, newValue: any, elementDesignId: string) => {
      const diagram = this.$store.state.ModuleMD.curDiagram;
      if (diagram !== null && diagram instanceof Diagram) {
        // 不能使用Diagram中的Component，因为其不会保存，使用应用树上加载的Component
        const component = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === diagram.component.designId) as BaseComponent;
        const tab = this.tabData.find(item => item.name === component.designId);
        diagram.isModified = true;
        tab.title = `[${EnumComponentTypeMD.getItemByValue(component.componentType).name.substring(0, 3)}]${component.displayName}`;
      } else {
        // 表示当前操作的是UI模型组件本身的属性变更，需要在应用树显示保存按钮
        let component = this.$store.state.ModuleMD.curComponent;
        if (component !== null) {
          if (elementDesignId === this.$store.state.ModuleMD.curComponent.designId) {
            component = this.$store.state.ModuleMD.elements.find((element: BaseElement) => element.designId === this.$store.state.ModuleMD.curComponent.designId) as BaseComponent;
          }
          if (component !== null && component instanceof UIModelComponent) {
            component.modify();
            const tab = this.tabData.find(item => item.name === component.designId);
            tab.title = `[${EnumComponentTypeMD.getItemByValue(component.componentType).name.substring(0, 3)}]${component.displayName}`;
          }
        }
      }
    });
  }

  beforeDestroy() {
    EventBus.$off('openDoc');
    EventBus.$off('openPage');
    EventBus.$off('pgValueChanged');
    EventBus.$off('removeTab');
  }

  get tabs(): any[] {
    return this.tabData;
  }

  get DocType() {
    return EnumDocType;
  }

  /** 图表被修改的标志 */
  modifyFlag(item: any): string {
    let isModified = false;
    if (item.type === EnumDocType.MDDiagramComponent) {
      const component = item.component;
      const diagram: Diagram = this.$store.state.ModuleMD.diagrams.find((diagram: Diagram) => diagram.component.designId === component.designId);
      isModified = diagram?.isModified;
    } else if (item.type === EnumDocType.MDPageComponent) {
      const component = item.component as BaseComponent;
      const uiModelComponent: UIModelComponent = this.$store.state.ModuleMD.uiModelComponents.find((element: UIModelComponent) => element.designId === component.designId);
      isModified = uiModelComponent?.persistenceStatus !== EnumPersistenceStatus.None; // 组件内的任何修改，都标记到组件的修改上。
    }
    return isModified ? '*' : '';
  }

  openDoc(component: BaseComponent) {
    const find = this.tabData.find(item => item.name === component.designId);
    if (find) {
    } else {
      let componentDocType = EnumDocType.MDDiagramComponent;
      if (component instanceof UIModelComponent) {
        componentDocType = EnumDocType.MDPageComponent;
      }
      this.tabData.push({ type: componentDocType, title: `[${EnumComponentTypeMD.getItemByValue(component.componentType).name.substring(0, 3)}]${component.displayName}`, name: component.designId, component: component });
    }
    this.curTab = component.designId;
  }

  openDocFaild(designId: string) {
    this.removeTab(designId);
  }

  openPage(url: string, name: string, displayName: string, transferData: any) {
    const find = this.tabData.find(item => item.name === name);
    if (find) {
    } else {
      this.tabData.push({ type: EnumDocType.WebPage, title: displayName, name: name, url: url, transferData: transferData });
    }
    this.curTab = name;
    this.$store.dispatch('ModuleMD/setCurDiagramAction', null);
  }

  clickTab(tab: any) {
    this.setCurTab(tab.name);
  }

  // 设置当前的TAB
  setCurTab(tabName: string) {
    const tabObj = this.tabData.find(item => item.name === tabName);
    if (tabObj) {
      if (tabObj.type === EnumDocType.MDDiagramComponent) {
        const diagram: any = this.$store.state.ModuleMD.diagrams.find((element: Diagram) => element.component.designId === tabName);
        this.$store.dispatch('ModuleMD/setCurDiagramAction', diagram);
      } else if (tabObj.type === EnumDocType.MDPageComponent) {
        this.$store.dispatch('ModuleMD/setCurDiagramAction', null);
        const component: any = this.$store.state.ModuleMD.uiModelComponents.find((element: UIModelComponent) => element.designId === tabName);
        this.$store.dispatch('ModuleMD/setCurComponentAction', component);
      } else if (tabObj.type === EnumDocType.WebPage) {
        this.$store.dispatch('ModuleMD/setCurDiagramAction', null);
      }
      this.curTab = tabName;
    }
    // TODO : 设置为当前选中图形
    this.$store.dispatch('ModuleMD/setCurCellIdAction', '');
    this.$store.dispatch('ModuleMD/setCurCellAction', null);
    this.$store.dispatch('ModuleMD/setCurMDDesignIdAction', '');
    this.$store.dispatch('ModuleMD/setCurMDElementAction', null);
  }

  removeTab(targetName: string) {
    const tabs = this.tabData;
    let activeName = this.curTab;
    if (activeName === targetName) {
      tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          const nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            activeName = nextTab.name;
          }
        }
      });
    }

    this.tabData = tabs.filter(tab => tab.name !== targetName);
    this.curTab = activeName;
    this.setCurTab(activeName);
  }
}
